import { PlanPurchaseProviderContextHook } from '@app/plans/src/purchase/PlanPurchaseProvider/context-hooks/PlanPurchaseProviderContextHook'
import { getPlans } from '@dtx-company/inter-app/src/api/subscription-service/getPlans'
import { useAPISWR } from '@dtx-company/inter-app/src/hooks/useAPISWR/useAPISWR'
import { useEffect } from 'react'

export const usePlanPurchaseProviderSelectedPlan: PlanPurchaseProviderContextHook = (
  props,
  context,
  updateContext
): void => {
  const { planInterval, planType, pricingGroup } = context

  // Load all plans up-front so we can re-select the selected plan synchronously if
  // the user changes any selections
  const plansSWR = useAPISWR(
    getPlans,
    {},
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false
    }
  )

  useEffect(() => {
    updateContext({ plans: plansSWR.data })
  }, [plansSWR.data, updateContext])

  useEffect(() => {
    if (!plansSWR.data) return
    const selectedPlan = plansSWR.data.find(plan => {
      return plan.interval === planInterval && plan.type === planType && plan.group === pricingGroup
    })
    updateContext({ selectedPlan })
  }, [plansSWR.data, planInterval, planType, pricingGroup, updateContext])
}
